module.exports = __webpack_public_path__ + "img/lipic2.b1222746.svg";